module.exports = __webpack_public_path__ + "static/media/apseal.da6c3cfd.png";